// Precedence bug made this always the RELATIVE "assets_mobile" (("/" + isMobile)
// is truthy), so nested URLs like /a/b resolved assets under the fake directory
// and crashed the scene. Keep serving the same assets_mobile files (what
// production has always served, desktop included); just make the path absolute.
export const assets_prefix = "/assets_mobile";
